import { StyleSheet, I18nManager, Dimensions, Platform } from 'react-native';
import Expo from 'expo';

export const dimensions = Dimensions.get('window');
const isIphoneX = Platform.OS === 'ios' && (Dimensions.get('window').height === 812 || Dimensions.get('window').width === 812); // Accounting for the height in either orientation

export const HEADER_HEIGHT = Platform.OS === 'android' ? 54 + Expo.Constants.statusBarHeight : isIphoneX ? 78 : 64;
export const STATUSBAR_HEIGHT = Platform.OS === 'web' ? 0 : isIphoneX ? 30 : Expo.Constants.statusBarHeight;
export const IPHONEX_MARGIN = isIphoneX ? 10 : 0;
export const TABBAR_HEIGHT = 50;
export const style = StyleSheet.create;
export const css = StyleSheet.create;
export const isRTL = I18nManager.isRTL;
export const forceRTL = I18nManager.forceRTL;

//const primary_color = '#3498db';
const warning_color = '#f1c40f';
const error_color = '#e74c3c';
const success_color = '#1abc9c';
const gray_color = '#2c3e50';

const primary_color = '#578bc1';
//const warning_color = "#ffea74";
//const error_color = '#fa6348';
//const success_color = '#00a396';
//const gray_color = '#000000';

export const lighten = (c, a) => {
  // whiting using white 255 background
  const m = (p1, p2) => ('0' + parseInt((1 - a) * 255 + a * parseInt(c[p1] + c[p2], 16), 10).toString(16)).slice(-2);
  const R = m(1, 2);
  const G = m(3, 4);
  const B = m(5, 6);
  return '#' + R + G + B;
};
export const alpha = (c, a) => {
  return `rgba(
    ${parseInt(c[1] + c[2], 16)},
    ${parseInt(c[3] + c[4], 16)},
    ${parseInt(c[5] + c[6], 16)},
  ${a})`;
};

export const theme = {
  font_xs: 10,
  font_sm: 12,
  font_md: 14,
  font_lg: 16,
  font_xl: 18,
  hairline: StyleSheet.hairlineWidth,
  absoluteFill: StyleSheet.absoluteFill,
  absoluteFillObject: StyleSheet.absoluteFillObject,
  // primary colors
  primary_color: primary_color,
  primary_color_lighten: (percent = 0.2) => lighten(primary_color, percent),
  primary_color_alpha: (percent = 0.2) => alpha(primary_color, percent),
  // gray colors
  gray_color: gray_color,
  gray_color_lighten: (percent = 0.2) => lighten(gray_color, percent),
  gray_color_alpha: (percent = 0.2) => alpha(gray_color, percent),
  // warning color
  warning_color: warning_color,
  warning_color_lighten: (percent = 0.2) => lighten(warning_color, percent),
  warning_color_alpha: (percent = 0.2) => alpha(warning_color, percent),
  // error color
  error_color: error_color,
  error_color_lighten: (percent = 0.2) => lighten(error_color, percent),
  error_color_alpha: (percent = 0.2) => alpha(error_color, percent),
  // error color
  success_color: success_color,
  success_color_lighten: (percent = 0.2) => lighten(success_color, percent),
  success_color_alpha: (percent = 0.2) => alpha(success_color, percent),
  alpha: alpha,
  lighten: lighten
};



// WEBPACK FOOTER //
// ./src/constants/theme.js